<!--
 * @Author: your name
 * @Date: 2021-01-21 10:49:52
 * @LastEditTime: 2021-03-12 14:14:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\views\Home\common\NoteDialog.vue
-->
<template>
  <div id='noteDialog'>
    <el-divider></el-divider>
    <!-- 添加发布通知 -->
    
    <span class="btns-operate">
      <el-button :class="noRepetition?'disableStyle':''" type="primary" size="small"  @click="send(2)">发 送</el-button>
      <el-button :class="noRepetition?'disableStyle close':'close'" size="small"  @click="cancel">关 闭</el-button>
      
    </span>
    <el-row>
      <el-form :model="addNoticeForm" :rules="addNoticeFormRules" ref="addNoticeForm" label-width="120px" class="demo-ruleForm">
        <el-row v-if="$route.name=='AdminManagement'">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item label="催缴年份" prop="year" >
              <el-select v-model="addNoticeForm.year" placeholder="请选择催缴年份" @change="callYear">
                <el-option v-for="item in yearList" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item label="通知类型" prop="notificationType">
              <el-select v-model="addNoticeForm.notificationType" placeholder="请选择通知类型" @change="handleSelect">
                <el-option v-for="item in notificationData" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item label="标题" prop="title">
              <el-input placeholder="不超过30个字符" v-model="addNoticeForm.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item label="接收人" class="recipient">
              <span v-if="$route.name=='Management'">{{$route.query.comName}}</span>
              <span v-else>默认为该年欠费会员</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="$route.name=='Management'">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item label="设置发送时间" prop="releaseTime" class="five">
              <el-select v-model="addNoticeForm.sendMode" placeholder="请选择发送时间">
                <el-option label="定时发送" :value="1">
                </el-option>
                <el-option label="立即发送" :value="2">
                </el-option>
              </el-select>
              <el-date-picker v-if="addNoticeForm.sendMode==1" v-model="addNoticeForm.releaseTimeStr" type="datetime" placeholder="选择日期时间" default-time="09:00:00">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="$route.name=='Management'">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item label="设置发送方式" prop="sendWay">
              <el-checkbox-group v-model="addNoticeForm.sendWay" @change="groupChange">
                <el-checkbox label="站内通知" name="1"></el-checkbox>
                <el-checkbox label="邮箱" name="2"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <el-form-item label="上传附件" prop="file">
              <el-upload class="upload-demo" :headers="headerObj" :action="uploadUrl" :on-success="handleSuccess"  :on-preview="handlePreview"  :file-list="UploadAttachmentList" :on-remove="removeAttachment" :limit="1">
                <span class="uploaadImg"><img src="@/assets/img/上传.png" alt="">点击上传</span>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <el-form-item >
              <el-tooltip class="item" effect="dark" :content="UploadAttachmentList.length==0?'上传附件后可进行选择':'请选择'" placement="top">
                <el-select v-model="addNoticeForm.fileType" placeholder="请选择" :disabled="UploadAttachmentList.length==0?true:false" >
                  <el-option v-for="item in fileSendWay" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="11" :xl="11">
            <el-form-item label="站内信正文" :prop="contentRequired == 'true'?'content':''" class="four">
              <quill-editor class="quill"  v-model="addNoticeForm.content" ref="myQuillEditor" :options="editorOption">
              </quill-editor>
            </el-form-item>
          </el-col>
          
          <el-col :xs="24" :sm="24" :md="24" :lg="11" :xl="11">
            
            <el-form-item label="邮件正文" :prop="contentRequired == 'true'?'mailContent':''" class="four transfer-relative">
              <quill-editor class="quill"  v-model="addNoticeForm.mailContent" ref="myQuillEditor" :options="editorOption">
              </quill-editor>
              <!-- 左右复制内容 -->
              <ul class="letter-mail-change">
                <li @click="conToMailcon()"><i class="el-icon-right"></i></li>
                <li @click="mailconToCon()"><i class="el-icon-back"></i></li>
              </ul>
            </el-form-item>
          </el-col>
        </el-row>
        
        
      </el-form>
    </el-row>
  </div>
</template>
<script>
import { addNotice, findMembershipFeeList } from '@/api/index'
export default {
  props: ['companyName','controlStatus','contentRequired'],
  data() {
    return {
      addNoticeVisible: false,
      isFadeIn: false,
      isFadeOut: false,
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike',],        // 加粗，斜体，下划线，删除线,链接
            ['blockquote', 'code-block'],                      //引用，代码块
            [{ 'header': 1 }, { 'header': 2 }],               // 几级标题
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],     // 有序列表，无序列表
            [{ 'script': 'sub' }, { 'script': 'super' }],      // 下角标，上角标
            [{ 'indent': '-1' }, { 'indent': '+1' }],          // 缩进
            [{ 'direction': 'rtl' }],                         // 文字输入方向
            [{ 'size': ['small', false, 'large', 'huge'] }],  // 字体大小
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],// 标题
            [{ 'color': [] }, { 'background': [] }],          // 颜色选择
            [{ 'font': [] }],// 字体
            [{ 'align': [] }], // 居中
            ['clean'],
            ['link',"image"]
          ]
        }
      },
      sendType: ['站内通知'],
      addNoticeForm: {
        year: '',
        notificationType: '',
        title: '',
        content: '',
        mailContent:'',
        fileType:null,
        fileList:'',
        recipientType: '',
        releaseTimeStr: '',
        sendWay: ['站内通知','邮箱'],
        saveType: '',
        sendMode: 2
      },
      addNoticeFormRules: {
        year: [{ required: true, message: '请输入催缴年份', trigger: 'change' }],
        notificationType: [{ required: true, message: '请输入通知类型', trigger: 'change' }],
        title: [{ required: true, message: '请输入通知类型', trigger: 'blur' },
        { min: 0, max: 30, message: '长度在 0到 30个字符', trigger: 'blur' }],
        // recipientType: [{ required: true, message: '请输入接收人类型', trigger: 'blur' }],
        sendMode: [{ required: true, message: '请输入发送时间', trigger: 'blur' }],
        releaseTimeStr: [{ required: true, message: '请输入发送时间', trigger: 'blur' }],
        content: [{ required: true, message: '请输入站内信正文', trigger: 'blur' }],
        mailContent: [{ required: true, message: '请输入邮件正文', trigger: 'blur' }],
      },
      headerObj: { token: window.sessionStorage.getItem('token') },
      uploadUrl: '', // 单文件
      UploadAttachmentList:[],
      fileSendWay:[
        {value:0,label:'仅站内信下载附件'},
        {value:1,label:'站内信和邮箱都可下载'}
      ],
      notificationData: [{
        value: 1,
        label: '公告'
      }, {
        value: 2,
        label: '提醒'
      },],
      yearList: JSON.parse(localStorage.getItem('payAllYear')),
      callPayData: [],
      noRepetition:false
    }
  },
  created() {
      this.uploadUrl = this.$http.defaults.baseURL + 'user/uploadFile'
  },
  methods: {
    // 上传附件
    handleSuccess(file, fileList) {
      this.message = "上传成功"
      this.UploadAttachmentList.push({ name: fileList.raw.name, url: fileList.response.fileUrl })
      this.addNoticeForm.fileType = 0
    },
    
    // 移除上传的附件
    removeAttachment(file) {
      const filePath = file.url
      // //使用findIndex来查找符合条件的索引
      const index = this.UploadAttachmentList.findIndex(item => item.url === filePath)
      // //移除索引对应的图片
      this.UploadAttachmentList.splice(index, 1)
      this.addNoticeForm.fileType = ''
    },
    handlePreview(param){
      if(param.url){
        window.open(param.url)
      }
    },
    conToMailcon(){
      this.addNoticeForm.mailContent = this.addNoticeForm.content
    },
    mailconToCon(){
      this.addNoticeForm.content = this.addNoticeForm.mailContent
    },
    send(type) {
      
      this.$refs.addNoticeForm.validate(async (valid) => {
        if (valid) {
          this.addNoticeForm.saveType = parseInt(type)
          if (this.$route.name == 'Management') {
            this.addNoticeForm.sendWay = this.addNoticeForm.sendWay.join(',')
            this.addNoticeForm.recipientType = this.$route.query.comName
            this.addNoticeForm.releaseTimeStr = this.addNoticeForm.releaseTimeStr ? this.$dayjs(this.addNoticeForm.releaseTimeStr).format("YYYY-MM-DD HH:mm:ss") : ''
          } else if (this.$route.name == 'AdminManagement') {
            this.addNoticeForm.sendMode = ''
            this.addNoticeForm.sendWay = ''
            this.addNoticeForm.recipientType = ''
            this.addNoticeForm.releaseTimeStr = ''
          }
          if(this.addNoticeForm.fileType == null){
            this.$delete(this.addNoticeForm,'fileType')
          }
          this.addNoticeForm.fileList = JSON.stringify(this.UploadAttachmentList)
          // 点击一次后禁止点击
          if(this.noRepetition){
            return
          }else{
            this.noRepetition = true
          }
          const { data } = await addNotice(this.addNoticeForm)
          
          if (data.code == 0) {
            this.$message.success("发布成功")
            this.addNoticeForm.sendWay = ['站内通知']
            this.addNoticeVisible = false
            this.noRepetition = false
            if(this.$route.name=='AdminManagement'){
              this.$parent.status = 4
            }else if(this.$route.name=='Management'){
              this.$parent.tabIndex = 0
            }
          } else {
            this.addNoticeForm.sendWay = ['站内通知']
            this.noRepetition = false
          }
        }
      })
    },
    cancel() {console.log(this.$parent);
      if(this.noRepetition){
        return
      }else{
        if(this.$route.name=='AdminManagement'){
          this.$parent.status = 4
        }else if(this.$route.name=='Management'){
          this.$parent.tabIndex = 0
        }
      }
      
    },
    closeDialog() {
      this.$refs.addNoticeForm.resetFields()
      this.addNoticeForm.sendMode = 2
    },
    groupChange(val) {
      this.addNoticeForm.sendWay = val
    },
    // 通知类型
    handleSelect(val) {
      if (val == 1) {
        this.isShowAll = true
      } else {
        this.isShowAll = false
      }
    },
    // 催缴年份
    async callYear(val) {
      const { data } = await findMembershipFeeList(val)
      if (data.code != 0) return
      this.callPayData = JSON.parse(JSON.stringify(data.membershipFeeList))
      this.addNoticeForm.content =
        `<h3 style='text-align:center;'>关于协会会费收取的通知</h3>
         <p>各信用服务行业协会会员单位:</p>
         <p style='text-indent:15px;'>按照本协会《章程》的规定，协会秘书处将从现在开始
         收取行业协会各会员单位、专委会成员单位的年度会费。收费标准如下：</p>
         <ol>
         <li>会长单位年会费为${this.callPayData[0].presidentFee}元。</li>
         <li>副会长单位年会费为${this.callPayData[0].vicePresidentFee}元。</li>
         <li style='font-weight:700;'>理事、专委会主任单位年会费为${this.callPayData[0].directorUnitFee}元。</li>
         <li>专委会副主任单位年会费为4000元。</li>
         <li>会员单位、专委会成员单位年会费为${this.callPayData[0].regularMemberFee}元。</li>
         </ol>
         <p style='text-indent:15px;'>请在收到通知后及时办理有关手续，会费到账后协会会将会费收据快递给贵公司（交费的具体工作也可与协会秘书处联系，电话：50396501  联系人：倪毓琳 朱晓玲）</p>
         <p style='text-indent:15px;'>交费方式：请将会费汇到协会帐户：</p>
         <p  style='text-indent:15px;font-weight:700;'>汇款帐户：上海市信用服务行业协会</p>
         <p  style='text-indent:15px;font-weight:700;'>开户行：上海浦东发展银行商城路支行</p>
         <p  style='text-indent:15px;font-weight:700;'>帐号：076596-98820154800000031</p>
         <p  style='text-indent:15px;'>特此通知</p>
        `
    },
  }
}
</script>
<style lang='less' scoped>
#noteDialog {
  position: relative;
  .btns-operate{
    position: absolute;
    right: 0;
    top:-46px;
    text-align: right;
    /deep/.el-button{
      padding: 0;
      width: 90px;
      font-size: 15px;
      height: 34px;
      line-height: 34px;
      border-radius: 17px;
      border: solid 1px #0566cc;
      text-align: center;
      background-image: linear-gradient(-45deg, #0566cc 0%, #3793f4 100%);
      color: #fff;
      margin-left: 20px;
    }
    /deep/.el-button.close{
      background-image: none;
      background-color: transparent;
      color: #0566cc;
    }
    /deep/.el-button.saveDraft{
      background-image: none;
      background-color: #0DD0C0;
      border-color: #0DD0C0;
    }
  }
  
  /deep/.quill {
    .ql-toolbar.ql-snow .ql-formats {
      margin-right: 5px;
    }
    .ql-toolbar.ql-snow + .ql-container.ql-snow{
      height:300px;
    }
  }
  /deep/.addNoticeVisible {
    .el-dialog__body {
      padding: 30px !important;
    }
    .four {
      // margin-bottom: 90px;
      .quill-editor {
        // height: 120px;
        .ql-toolbar.ql-snow {
          line-height: 20px !important;
        }
      }
    }
    .five {
      .el-date-editor.el-input {
        margin-left: 20px;
      }
      .el-input--prefix .el-input__inner {
        height: 36px;
        border-radius: 18px;
        border: solid 1px #0e6fd0;
      }
      .el-icon-time:before {
        color: #0e6fd0;
      }
    }
    .save {
      background-color: #0ed0c0;
      border: solid 1px #fff;
    }
    .recipient {
      .el-checkbox {
        margin-right: 20px;
      }
      .el-link {
        line-height: 23px;
        color: #409eff;
      }
    }
    .el-input__inner {
      background: #fff;
    }
    .disableStyle{
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
  .uploaadImg {
    display: inline-block;
    width: 134px;
    height: 34px;
    line-height: 34px;
    border-radius: 17px;
    border: solid 1px #0566cc;
    color: #0066cc;
    font-size: 16px;
    margin-right: 15px;
    cursor: pointer;
    img {
      vertical-align: middle;
      padding-right: 5px;
    }
  }
  .transfer-relative{
  /deep/.el-form-item__content{
    position: relative;
    .letter-mail-change{
      position: absolute;
      top: 160px;
      left: -70px;
      li{
        width: 50px;
        height: 18px;
        text-align: center;
        line-height: 18px;
        color: #A4A4A5;
        border-radius: 20px;
        border: 1px solid #A4A4A5;
        margin-bottom: 10px;
        cursor: pointer;
        font-size:20px;
      }
      li.lm-active{
        color: #3D89D7;
        border-color: #3D89D7;
      }
      li:hover{
        color: #3D89D7;
        border-color: #3D89D7;
      }
    }
  }
  
}
  
}
</style>
